import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'layout',
        redirect: {
            name: 'profile-user'
        },
        component: () => import(/* webpackChunkName: "dashboard" */'../views/dashboard.vue'),
        children: [
            {
                path: 'user',
                name: 'profile-user',
                component: () => import('../views/profile/index.vue'),
            },
            {
                path: 'history-money',
                name: 'history-money',
                component: () => import('../views/money/index.vue'),
            },
            {
                path: 'raovat',
                name: 'raovat',
                component: () => import(/* webpackChunkName: "raovat" */'../views/raovat/index.vue'),
            },
            {
                path: 'raovat/expired',
                name: 'raovat-expired',
                component: () => import(/* webpackChunkName: "raovat"*/'../views/raovat/expired/index.vue'),
            },
            {
                path: 'raovat/auto-up',
                name: 'raovat-auto-up',
                component: () => import(/* webpackChunkName: "raovat" */'../views/raovat/autoUp.vue'),
            },
            {
                path: 'raovat/create',
                name: 'raovat-create',
                component: () => import(/* webpackChunkName: "raovat" */'../views/raovat/create/index.vue'),
            },
            {
                path: 'raovat/:id',
                name: 'raovat-update',
                component: () => import(/* webpackChunkName: "raovat" */'../views/raovat/update.vue'),
            },
            {
                path: 'raovat/auto-up/up',
                name: 'raovat-auto-up-show',
                component: () => import(/* webpackChunkName: "raovat" */'../views/raovat/autoUpShow.vue'),
            },
            {
                path: 'static_pages',
                name: 'static_pages',
                component: () => import(/* webpackChunkName: "static_pages" */'../views/staticPages/index.vue'),

            },
            {
                path: 'static_pages/create',
                name: 'static_pages-create',
                component: () => import(/* webpackChunkName: "static_pages" */'../views/staticPages/create.vue'),

            },
            {
                path: 'static_pages/update',
                name: 'static-pages-update',
                component: () => import(/* webpackChunkName: "static_pages" */'../views/staticPages/create.vue'),
            },
            {
                path: 'keyword-reject',
                name: 'keyword-reject',
                component: () => import(/* webpackChunkName: "keyword-reject" */'../views/keywordRreject/index.vue'),
            },
            {
                path: 'hoidap',
                name: 'hoidap',
                component: () => import(/* webpackChunkName: "hoidap" */ '../views/hoidap/index.vue')
            },
            {
                path: 'hoidap/create',
                name: 'hoidap-create',
                component: () => import(/* webpackChunkName: "hoidap" */ '../views/hoidap/create.vue')
            },
            {
                path: 'hoidap/:id',
                name: 'hoidap-update',
                component: () => import(/* webpackChunkName: "hoidap" */ '../views/hoidap/update.vue')
            },
            {
                path: 'product',
                name: 'product',
                component: () => import(/* webpackChunkName: "sanpham" */'../views/product/index.vue'),
            },
            {
                path: 'product/expired',
                name: 'product-expired',
                component: () => import(/* webpackChunkName: "sanpham" */'../views/product/expired/index.vue'),
            },
            {
                path: 'product/promotion',
                name: 'product-promotion',
                component: () => import(/* webpackChunkName: "sanpham" */'../views/product/promotion/index.vue'),
            },
            {
                path: 'product/category',
                name: 'product-category',
                component: () => import(/* webpackChunkName: "sanpham" */'../views/product/category/index.vue'),
            },
            {
                path: 'product/category-group',
                name: 'product-category-group',
                component: () => import(/* webpackChunkName: "sanpham" */'../views/product/groupCategory/index.vue'),
            },
            {
                path: 'product/create',
                name: 'product-create',
                component: () => import(/* webpackChunkName: "sanpham" */'../views/product/create/index.vue'),
            },
            {
                path: 'product/don-hang',
                name: 'product-don-hang',
                component: () => import(/* webpackChunkName: "sanpham" */'../views/product/orders/index.vue'),
            },
            {
                path: 'product/create/step2/:id',
                name: 'product-create-step2',
                component: () => import(/* webpackChunkName: "sanpham" */'../views/product/create/step2.vue'),
            },
            {
                path: 'product/create/:id',
                name: 'product-create-fast',
                component: () => import(/* webpackChunkName: "sanpham" */'../views/product/create/postFast.vue'),
            },
            {
                path: 'product/edit/:id',
                name: 'product-edit',
                component: () => import(/* webpackChunkName: "sanpham" */'../views/product/edit/index.vue'),
            },
            {
                path: 'product/auto-up/up',
                name: 'product-auto-up',
                component: () => import(/* webpackChunkName: "raovat" */'../views/product/autoUp.vue'),
            },
            {
                path: 'product/action-ppc',
                name: 'product-action-ppc',
                component: () => import(/* webpackChunkName: "raovat" */'../views/product/ppc.vue'),
            },
            {
                path: 'product/action-keyword-sale',
                name: 'product-action-keyword-sale',
                component: () => import(/* webpackChunkName: "raovat" */'../views/product/keywordSale.vue'),
            },
            {
                path: 'product/action-product-sale',
                name: 'product-action-product-sale',
                component: () => import(/* webpackChunkName: "raovat" */'../views/product/sale.vue'),
            },
            {
                path: 'category/create',
                name: 'category-create',
                component: () => import(/* webpackChunkName: "raovat" */'../views/category/create/index.vue'),
            },
            {
                path: 'category/edit/:id',
                name: 'category-edit',
                component: () => import(/* webpackChunkName: "raovat" */'../views/category/edit/index.vue'),
            },
            {
                path: 'category',
                name: 'category',
                component: () => import(/* webpackChunkName: "raovat" */'../views/category/index.vue'),
            },
            {
                path: 'product/:id',
                name: 'product-update',
                component: () => import(/* webpackChunkName: "sanpham" */ '../views/product/update.vue'),
            },
            {
                path: 'message',
                name: 'message',
                component: () => import(/* webpackChunkName: "message" */ '../views/message/index.vue')
            },
            {
                path: 'message/:id',
                name: 'message-show',
                component: () => import(/* webpackChunkName: "message" */ '../views/message/show.vue')
            }
            // {
            //     path: 'google',
            //     name: 'google',
            //     component: () => import(/* webpackChunkName: "raovat" */ '../views/google.vue')
            // },
        ],
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.VUE_APP_BASE,
    routes
})

export default router
